module.exports = __webpack_public_path__ + "img/product-placeholder-32.6b45bf9.png";